<template>
  <base-header class="pt-md-2 pb-md-5">
    <div class="row">
      <div class="col-xl-4 col-lg-6">
        <stats-card
          title="Number of Users"
          type="black"
          url="users"
          :subTitle="(dashboard) ? dashboard.users : 0"
          class="mb-xl-0 common-box"
        ></stats-card>
      </div>
      <div class="col-xl-4 col-lg-6">
        <stats-card
          title="Number of Products"
          type="green"
          url="products"
          :subTitle="(dashboard) ? dashboard.products : 0"
          class="mb-xl-0 common-box"
        ></stats-card>
      </div>
      <div class="col-xl-4 col-lg-6">
        <stats-card
          title="Number of Newsfeeds"
          type="yellow"
          url="news-feed"
          :subTitle="(dashboard) ? dashboard.newsfeeds : 0"
          class="mb-xl-0 common-box"
        ></stats-card>
      </div>
    </div>
    <div class="row">
      <div class="col-xl-8 col-lg-8 my-9">
        <v-card class="pa-4 chart-box common-box">
          <line-chart></line-chart>
        </v-card>
      </div>
      <div class="col-xl-4 col-lg-4 my-9">
        <v-card class="pa-4 chart-box common-box">
          <pie-chart></pie-chart>
        </v-card>
      </div>
    </div>
      <v-card class="px-6 py-5 mt-3 common-box">
        <v-list-item-title class="list-item-title">Statistics and Roles</v-list-item-title>
          <div :class="$vuetify.breakpoint.mdAndUp ? 'd-flex state-box' : 'state-box'">
            <v-list-item>
                <img class="pa-4" src="@/assets/images/Sales.svg" />
              <v-list-item-content>
                <v-list-item-title class="statistics-list-item-title">0k</v-list-item-title>
                <v-list-item-subtitle class="list-item-subtitle">Sales</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <img class="pa-4" src="@/assets/images/Users.svg" />
              <v-list-item-content>
                <v-list-item-title class="statistics-list-item-title">{{ (dashboard) ? dashboard.users : 0}}</v-list-item-title>
                <v-list-item-subtitle class="list-item-subtitle">Users</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <img class="pa-4" src="@/assets/images/Products.svg" />
              <v-list-item-content>
                <v-list-item-title class="statistics-list-item-title">{{ (dashboard) ? dashboard.products : 0}}</v-list-item-title>
                <v-list-item-subtitle class="list-item-subtitle">Products</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <img class="pa-4" src="@/assets/images/Newsfeed.svg" />
              <v-list-item-content>
                <v-list-item-title class="statistics-list-item-title">{{ (dashboard) ?  dashboard.newsfeeds : 0}}</v-list-item-title>
                <v-list-item-subtitle class="list-item-subtitle">Newsfeeds</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <img class="pa-4" src="@/assets/images/Revenue.svg" />
              <v-list-item-content>
                <v-list-item-title class="statistics-list-item-title">0k</v-list-item-title>
                <v-list-item-subtitle class="list-item-subtitle">Revenue</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </div>
      </v-card>
  </base-header>
</template>

<script>
import { UserService } from "@/services";

export default {
  components: {
    pieChart: () => import("@/components/Charts/Piechart"),
    lineChart: () => import("@/components/Charts/LineChart"),
  },
  data: () => ({
    dashboard: null,
  }),
  created() {
    this.initialize();
  },
  methods: {
    async initialize() {
      const dashboardInfo = await UserService.getDashboardDetails();
      this.dashboard = dashboardInfo.data.data && dashboardInfo.data.data[0] ? dashboardInfo.data.data[0] : 0;
    },
  },
};
</script>

<style lang="scss" scoped>
.list-item-title {
  font-size: 20px;
  font-weight: 500;
  color: #344452;
}
.state-box {
  padding-left: 40px;
  padding-right: 12px;
  padding-bottom: 2px;
}
.statistics-list-item-title {
  font-size: 16px;
  font-weight: 400;
  color: #344452;
}
.chart-box {
  height: 400px;
}
.common-box {
  box-shadow: none !important;
  box-sizing: border-box;
  border-radius: 4px;
  border: 1px solid #D6E0EF;
}
</style>